import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-update-evaluation',
  templateUrl: './update-evaluation.component.html',
  styleUrl: './update-evaluation.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class UpdateEvaluationComponent implements OnInit {
  minValues: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  maxValues: number[] = [15, 15, 5, 20, 10, 5, 5, 5, 5, 5, 5, 5];
  public showSpinner = true;
  bsInlineValue = new Date();
  bsInlineRangeValue!: Date[];
  maxDate = new Date();
  kpValues: any[] = [];
  rating: any[] = [];
  pm_rating: any[] = [];
  data: any;
  band1 = false;
  band2 = false;
  band3 = false;
  band4 = false;
  ratingValue: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  user: any;
  latestData: any;
  user_role: any;
  roleType: any;
  evaluation: any;
  publishValue = '0';
  publishValue1 = '0';
  evaluations: any;
  userInput = '';
  totalRating1: any;
  getDate: any;
  constructor(private evaluationService: EvaluationService,
    private route: ActivatedRoute,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    public datepipe: DatePipe,
    private router: Router) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    this.user_detail();
    this.data = {
      id: JSON.parse(this.route.snapshot.queryParams.id),
      data: JSON.parse(this.route.snapshot.queryParams.data),
    }
  }
  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getevaluation()
  }
  onInputChange() {
    this.pm_rating.forEach((value, index) => {
      if (!value || value === '') {
        this.pm_rating[index] = 0;
      } else {
        this.pm_rating[index] = value;
      }
    });

    this.updateTotalRating();
  }
  onInputChangeRating() {
    this.rating.forEach((value, index) => {
      if (!value || value === '') {
        this.rating[index] = 0;
      } else {
        this.rating[index] = value;
      }
    });
    this.updateTotalRating();
  }
  updateTotalRating() {
    if (this.roleType === "Admin") {
      this.totalRating1 = this.pm_rating.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0);
    } else if (this.roleType === "Team_Lead") {
      this.totalRating1 = this.rating.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0);
    }
    if (this.totalRating1 <= 25) {
      this.band1 = true;
      this.band2 = false;
      this.band3 = false;
      this.band4 = false;
    }
    else if (this.totalRating1 > 25 && this.totalRating1 <= 50) {
      this.band1 = false;
      this.band2 = true;
      this.band3 = false;
      this.band4 = false;
    }
    else if (this.totalRating1 > 50 && this.totalRating1 <= 75) {
      this.band1 = false;
      this.band2 = false;
      this.band3 = true;
      this.band4 = false;
    }
    else if (this.totalRating1 > 75) {
      this.band1 = false;
      this.band2 = false;
      this.band3 = false;
      this.band4 = true;
    }
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  cancel() {
    this.router.navigate(['/evaluation-list']);
  }

  onSubmit(form: NgForm) {
    const formData = form.value;
    const publish = this.publishValue;
    this.rating = [];
    for (let i = 0; i < 12; i++) {
      this.rating.push(formData['rating' + i]);
    }
    // For PM Rataing submit on form
    this.pm_rating = [];
    for (let i = 0; i < 12; i++) {
      this.pm_rating.push(formData['pm_rating' + i]);
    }
    const points = (this.rating || []).every((value: any) => parseInt(value) === 0) ? 0 : (this.rating.reduce((partial_sum: any, a: any) => parseInt(partial_sum) + parseInt(a), 0) / 10);
    const pm_points = this.pm_rating.reduce((partial_sum1: any, a: any) => parseInt(partial_sum1) + parseInt(a), 0) / 10;
    let model: any = {};
    if (this.data.data != null) {
      const date = new Date(formData.ev_date);
      model = {
        month_int: date.getMonth() + 1,
        month_char: this.datepipe.transform(date, "MMMM"),
        month_year: date.getFullYear(),
        user_id: this.data.data.id,
        kps_value: this.rating.toString(),
        pm_values: this.pm_rating.toString(),
        points: points,
        pm_points: pm_points,
        date: this.datepipe.transform(date, 'yyyy/MM/dd HH:mm:ss'),
        is_evaluation: publish
      };
    }
    this.showSpinner = true
    this.evaluationService.addOrUpdateKPV(model).then(response => {
      this.showSpinner = false
      if (response.success) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Evalaution Added Successfully!',

          showConfirmButton: false,
          timer: 3000,
        });

        this.router.navigate(['/evaluation-list']);
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: response.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }

    });
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })
  }
  getevaluation() {
    const id = this.data.id
    this.evaluationService.getevaluationedid(id).then((value: any) => {
      if (value.success) {
        this.showSpinner = false
        this.evaluations = value.data.data;
        const id = value.data.data.user_id
        this.evaluationService.getKPVList(id).then(response => {
          if (response) {
            this.showSpinner = false
            this.kpValues = response.data;
          }
        });
        if (this.data != null) {
          const evaluation = value.data.data
          this.latestData = evaluation;
          this.publishValue1 = this.latestData.is_evaluation;
          this.publishValue = this.publishValue1;
          const dateString = this.latestData.date;
          const datePart = dateString.split(" ")[0];
          this.getDate = datePart;
          const kpsValueString = this.latestData.kps_value;
          const pmValueString = this.latestData.pm_values;
          if (this.latestData.kps_value != null && this.latestData.pm_values != null) {
            const kpsValueArray = kpsValueString.split(',').map((value: string) => parseInt(value.trim(), 10));
            const pmValueArray = pmValueString.split(',').map((value: string) => parseInt(value.trim(), 10));
            this.rating = kpsValueArray;
            this.pm_rating = pmValueArray;
          }
          else if (this.latestData.kps_value != null && this.latestData.pm_values == null) {
            const kpsValueArray = kpsValueString.split(',').map((value: string) => parseInt(value.trim(), 10));
            this.rating = kpsValueArray;
            this.pm_rating = Array(12).fill(0);
          }
          else if (this.latestData.kps_value == null && this.latestData.pm_values != null) {
            this.rating = Array(12).fill(0);
            const pmValueArray = pmValueString.split(',').map((value: string) => parseInt(value.trim(), 10));
            this.pm_rating = pmValueArray;
          }
          else {
            this.rating = Array(12).fill(0);
            this.pm_rating = Array(12).fill(0);
          }
          if (this.roleType === "Admin") {
            this.onInputChange();
          }
          if (this.roleType === "Team_Lead") {

            this.onInputChangeRating();
          }
        }
        this.maxDate.setDate(this.maxDate.getDate() + 7);
        this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
      }
    });
  }

}
